import { IFinanceDialogProps } from "../constants/FinanceModels";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";

function FinanceDialog(props: IFinanceDialogProps) {
    return (<>
            {props.open && <Dialog open={props.open} fullWidth={true} onClose={() => {
                props.onClose()
            }}>
                <DialogTitle>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {props.titleIcon}
                        <Typography sx={{ paddingLeft: "10px" }} fontWeight={"bold"} color={"primary"}>
                            {props.title}
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ padding: "15px" }} alignItems={"center"}>
                        <Grid item>
                            <Typography color={"primary"} variant={"body1"} style={{ whiteSpace: "pre-line" }}>
                                {props.content}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant={props.confirmButton ? "outlined" : "contained"} color={"accent"} onClick={() => {
                        if (props.onCancel) {
                            props.onCancel();
                        }
                        props.onClose()
                    }}>{props.cancelButton}</Button>
                    {props.callback && <Button color={"accent"} onClick={() => {
                        props.onClose();
                        if (props.callback) {
                            props.callback();
                        }
                    }}>{props.confirmButton}</Button>}
                </DialogActions>
            </Dialog>}
        </>
    )
}

export default FinanceDialog;